var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93381 5.25288C8.65098 3.6769 7.48969 2.4163 5.98988 2.02476C5.45467 1.88503 5 2.3573 5 2.92364V4.22347C4.4022 4.57808 4 5.24087 4 6C4 6.75912 4.4022 7.42192 5 7.77653V9.07636C5 9.6427 5.45467 10.115 5.98988 9.97524C7.48969 9.5837 8.65098 8.3231 8.93381 6.74712C8.95562 6.74902 8.97769 6.75 9 6.75H13C14.2426 6.75 15.25 7.75736 15.25 9V21.25H11C10.5858 21.25 10.25 21.5858 10.25 22C10.25 22.4142 10.5858 22.75 11 22.75H21C21.4142 22.75 21.75 22.4142 21.75 22C21.75 21.5858 21.4142 21.25 21 21.25H16.75V9C16.75 6.92893 15.0711 5.25 13 5.25H9C8.97769 5.25 8.95562 5.25098 8.93381 5.25288Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp1);
export default __webpack_public_path__ + "static/media/lamp-1.8e3850aecbd8d257c7987416feb57019.svg";
export { ForwardRef as ReactComponent };